import { ExecutionSummary, RuleDetails } from './execution';
import { Group } from './group';
import { Job } from './job';
import { Rule } from './rule';
import { Variable } from './variable';

export const defaultJob: Job = {
  Name: '',
  Description: '',
  RowDataLimit: 200,
  SchoolYear: new Date().getFullYear(),
  Variables: [],
  Rules: [],
  Groups: [],
};

export const defaultRule: Rule = {
  Name: '',
  Statement: '',
  LongDescription: '',
  ShortDescription: '',
};

export const defaultVariable: Variable = {
  Name: '',
  Description: '',
};

export const defaultGroup: Group = {
  Name: '',
  Rules: [],
};

export const defaultExecutionSummary: ExecutionSummary = {
  Job: '',
  Status: '',
  Rules: [],
  ExecutedAt: new Date(),
};

export const defaultRuleDetails: RuleDetails = {
  Rule: '',
  Severity: '',
  ShortDescription: '',
  LongDescription: '',
  Status: '',
  TotalErrors: 0,
  DisplayedErrors: 0,
  Duration: 0,
  Rows: [],
};
